module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dots.length) ? _c('ul', {
    staticClass: "dots"
  }, _vm._l((_vm.dots), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "dots__item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.$emit('clickDot', index)
        }
      }
    }, [_c('button', {
      staticClass: "dots__btn",
      class: {
        'dots__btn_active': _vm.active === index
      }
    })])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8287f5c6","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/slider/images/components/CardSliderNavDots.vue
// module id = e8fc48103c2a90a9dc27
// module chunks = 0